module.exports = __webpack_public_path__ + "static/img/icon_hzl.464926c7.png";